import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Master";
import getToken from "app/api/getToken";
import { IMaster } from "app/api/types/Masters";

export const DELETE_MASTER_DIPLOMA_REQUEST = "DELETE_MASTER_DIPLOMA_REQUEST";
export const DELETE_MASTER_DIPLOMA_SUCCESS = "DELETE_MASTER_DIPLOMA_SUCCESS";
export const DELETE_MASTER_DIPLOMA_FAIL = "DELETE_MASTER_DIPLOMA_FAIL";

export const deleteMasterDiploma = (name: string, masterId: number) => (
  dispatch: any
): any => {
  dispatch({ type: DELETE_MASTER_DIPLOMA_REQUEST });

  const token = getToken();

  return api
    .deleteMasterDiploma(token, name, masterId)
    .then((response: AxiosResponse) => {
      const master: IMaster = get(response, "data", {});
      dispatch({ type: DELETE_MASTER_DIPLOMA_SUCCESS, payload: master });

      return master;
    })
    .catch(err => {
      dispatch({
        type: DELETE_MASTER_DIPLOMA_FAIL,
        payload: get(err, "response.data.errors", {})
      });
      throw get(err, "response.data.errors", {});
    });
};
